<template>
    <b-container fluid class="mt--7">
        <list-items
            v-if="isList"
            title="Master Items"
            ref="table"
            @report-state="loading = $event"
        >
            <import-form
                subject="Inventory"
                v-model="importModal"
                @cancel="hideModal()"
                :fields="inventoryFields"
                :upload-record="uploadInventoryRecord"
                settings-key-name="inventoryUploadKey"
            ></import-form>

            <b-button-group class="float-right">
                <b-button
                    variant="primary"
                    v-if="hasPermissionCreate"
                    :to="`${$route.path}/0`"
                    >Add</b-button
                >
                <b-button
                    variant="primary"
                    @click="importModal = true"
                    v-if="hasPermissionCreate"
                    >Import</b-button
                >
                <b-button
                    variant="secondary"
                    @click="exportMasterItems()"
                    v-if="hasPermissionView"
                >
                    <b-spinner small v-if="loading"></b-spinner>
                    <span v-else> Export</span>
                </b-button>
                <b-button
                    variant="info"
                    to="/admin/section-items"
                    v-if="hasPermissionView"
                    >Sections</b-button
                >
            </b-button-group>
        </list-items>
        <view-item @success="alertSuccess" :id="id" v-else></view-item>
    </b-container>
</template>
<script>
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ImportForm from '@/components/ImportForm.vue'
import showItemHelper from '@/mixins/showItemHelper'
import importMixins from '@/mixins/importMixins'

const inventoryFields = [
    { name: 'name', required: true, type: 'text' },
    { name: 'ext_reference_code', required: true, type: 'text' },
    { name: 'description', required: false, type: 'text' },
    { name: 'vendor', required: true, type: 'text' },
    { name: 'uom', required: false, type: 'text' },
    { name: 'selling_price', required: true, type: 'text' },
    { name: 'item_type_name', required: true, type: 'text' },
]
export default {
    name: 'MasterItems',
    components: {
        ListItems,
        ViewItem,
        ImportForm,
    },
    mixins: [popupMixins, showItemHelper, permissionsMixins, importMixins],
    data: () => {
        return {
            item: null,
            importModal: false,
            loading: false,
            inventoryFields,
        }
    },
    created() {
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('assets/listVendors')
    },
    computed: {
        items() {
            const items = this.$store.state.masterItem.items
            console.log('items', items)
            return items
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },

        vendors() {
            return this.$store.state.assets.vendors
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },
    },

    methods: {
        alertSuccess(message) {
            this.doToast('Success', message, 'success')
        },
        exportMasterItems() {
            this.$refs.table.generateReport()
        },

        async uploadInventoryRecord(
            dataRecord,
            statusRecord,
            check,
            statuses,
            setLoading
        ) {
            try {
                let {
                    name,
                    ext_reference_code,
                    description,
                    vendor: vendor_name,
                    uom,
                    selling_price,
                    item_type_name,
                    active = true,
                } = dataRecord

                statusRecord.status = statuses.CHECKING

                if (check != 1) throw new Error('Invalid Entry!')
                const vendor_id = this.getCustomEntityId(
                    vendor_name,
                    this.vendors,
                    'name',
                    'Vendor'
                )

                const order_item_type_id = this.getCustomEntityId(
                    item_type_name,
                    this.itemTypes,
                    'name',
                    'Order Item Type'
                )

                const fetchparam = {
                    query: '',
                    page: 1,
                    filters: { ext_reference_code },
                }
                await this.$store.dispatch('masterItem/fetch', fetchparam)
                const items = this.$store.state.masterItem.items

                console.log({ items })

                if (items.length > 0) {
                    throw new Error('Duplicate Entry!')
                }
                const param = {
                    name,
                    ext_reference_code,
                    description,
                    vendor_id,
                    uom,
                    selling_price,
                    order_item_type_id,
                    active,
                }
                console.log({ param })

                const res = await this.$store.dispatch(
                    'masterItem/create',
                    param
                )
                console.log('response:', res)
                // set status to complete if the upload was successful
                statusRecord.status = statuses.COMPLETE
            } catch (err) {
                console.error('err', err)
                statusRecord.error_list =
                    typeof err.message == 'string'
                        ? [['error', [err.message]]]
                        : Object.entries(err.message)
                statusRecord.status = statuses.ERROR
            } finally {
                setLoading(false)
            }
        },
    },
}
</script>
<style></style>
